import { OverlayModule } from '@angular/cdk/overlay';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { BaselayerDropdownComponent } from './layerswitcher/baselayer-dropdown/baselayer-dropdown.component';
import { LayerControlComponent } from './layerswitcher/layer-control/layer-control.component';
import { LayerswitcherComponent } from './layerswitcher/layerswitcher.component';
import { LegendComponent } from './legend/legend.component';
import { MapComponent } from './map/map.component';



@NgModule({
  declarations: [
    LayerswitcherComponent,
    BaselayerDropdownComponent,
    LayerControlComponent,
    MapComponent,
    LegendComponent

  ],
  imports: [
    SharedModule,
    OverlayModule

  ],

  exports: [LayerswitcherComponent,
    MapComponent, LegendComponent]
})
export class MapOpenlayersModule { }
